export default {
  methods: {
    refreshOrderStatusWidgets(sourceWid, workspaceId) {
      if (!workspaceId) {
        workspaceId = this.$store.getters['workspaceManager/activeWorkspace'].id;
      }
      if (!this.$route || this.$route.name !== 'widget-popout') {
        //Non-Popout - Trigger refresh in the main window
        const orderStatusWidgets = this.$store.getters['widget/workspaceWidgets'](workspaceId, 'orderStatus');
        orderStatusWidgets.forEach(wid => {
          const inlineEditing = this.$store.state.widget[wid].inlineEditing;
          if (!inlineEditing || sourceWid === wid) {
            this.$store.dispatch(`widget/${wid}/triggerGridRefresh`);
          }
        });
      } else {
        //For Popout window
        //refresh the current popout
        if (sourceWid) {
          this.$store.dispatch(`widget/${sourceWid}/triggerGridRefresh`);
        }
        //delegate refresh to the main window
        localStorage.setItem('mm5.orderStatusRefresh', localStorage.getItem('mm5.orderStatusRefresh') ? '' : '1');
      }

      //refresh all popout widgets
      localStorage.setItem(
        'mm5.popout.orderStatusRefresh',
        localStorage.getItem('mm5.popout.orderStatusRefresh') ? '' : '1'
      );
    }
  }
};
